import OverviewInterface from "./OverviewInterface"

class PeopleOverview extends OverviewInterface {

    constructor() {
        super()
        this.linkedtype = 'people'
        this.setMappingName()
        this.fetchRoute = "overview.people.init"
    }

}

export default PeopleOverview